module.exports = __webpack_public_path__ + "static/media/discando.f56ee315.svg";